import { render, staticRenderFns } from "./beanOrderList.vue?vue&type=template&id=ec5bc8ca&scoped=true"
import script from "./beanOrderList.vue?vue&type=script&lang=js"
export * from "./beanOrderList.vue?vue&type=script&lang=js"
import style0 from "./beanOrderList.vue?vue&type=style&index=0&id=ec5bc8ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec5bc8ca",
  null
  
)

export default component.exports